import { ENUM__redux_slice } from './ENUM__redux_slice';

export const ENUM__redux_action = {
  //SYSTEM
  PERSIST_SAVE_STATE: 'persist/SAVE_STATE',
  PERSIST_REHYDRATE: 'persist/REHYDRATE',
  PERSIST_PURGE: 'persist/PURGE',
  PERSIST_PERSIST: 'persist/PERSIST',

  //GLOBAL
  GLOBAL_RESET: 'global/GLOBAL_RESET',
  GLOBAL_UNDO: 'global/GLOBAL_UNDO',

  //NETWORK
  NETWORK_SET_STATE: `${ENUM__redux_slice.NETWORK}/setState`,
  NETWORK_SET_ERRORS: `${ENUM__redux_slice.NETWORK}/set_errors`,
  NETWORK_SET_AVG_SERVER_LATENCY: `${ENUM__redux_slice.NETWORK}/set_avg_server_latency`,
  NETWORK__SET_WAITING_RESPONSE: `${ENUM__redux_slice.NETWORK}/set_waiting_response`,

  /*
   * ADMIN
   */
  ADMIN_USERS_ONLINE_UPSERT: `${ENUM__redux_slice.ADMIN_USERS}/online_upsert`,

  /*
   * APP INFO
   */
  APP_INFO_UPSERT: `${ENUM__redux_slice.APP_INFO}/upsert`,

  /*
   * COLLECTION
   */
  COLLECTION_UPSERT: `${ENUM__redux_slice.COLLECTION}/upsert_collection`,
  COLLECTION_DELETE: `${ENUM__redux_slice.COLLECTION}/delete_collection`,
  COLLECTION_CELLS_DELETE: `${ENUM__redux_slice.COLLECTION}/delete_cells`,
  COLLECTION_CELLS_UPSERT: `${ENUM__redux_slice.COLLECTION}/upsert_cells`,

  COLLECTIONS_SET_CURRENT: `${ENUM__redux_slice.COLLECTION}/collections_set_current`,

  COLLECTIONS_SPECIAL_INFO_SET_CURRENT: `${ENUM__redux_slice.COLLECTION}/special_info_collections_upsert_set_current`,
  COLLECTIONS_SPECIAL_INFO_UPSERT: `${ENUM__redux_slice.COLLECTION}/special_info_collections_upsert`,

  SET_SPECIAL_COLLECTIONS_BY_WORKSPACE_ID: `${ENUM__redux_slice.COLLECTION}/set_special_collections_by_workspace_id`,

  /*
   * COMMAND
   */

  /*s
   * DIFFUSION MODELS UD
   */

  ML_ASSET_RESERVATION_DELETE: `${ENUM__redux_slice.ML_ASSET}/reservations_delete`,
  ML_ASSET_RESERVATIONS_UPSERT: `${ENUM__redux_slice.ML_ASSET}/reservations_upsert`,
  ML_ASSET_RESERVATIONS_UPDATE_ACTIVE: `${ENUM__redux_slice.ML_ASSET}/reservations_update_active`,

  ML_ASSET_UPSERT_MODEL: `${ENUM__redux_slice.ML_ASSET}/upsert_model`,
  ML_ASSET_UPSERT_TABLE_PAGE: `${ENUM__redux_slice.ML_ASSET}/upsert_table_page`,
  ML_ASSET_UPSERT_TABLE_WITHOUT_PAGES: `${ENUM__redux_slice.ML_ASSET}/upsert_table_without_pages`,
  ML_ASSET_SET_CURRENT_TABLE_PAGE_SETTINGS: `${ENUM__redux_slice.ML_ASSET}/set_current_table_page_settings`,

  /*
   * GENERATION
   */

  GENERATION_SET_FIELD_IMAGE_TO_EDIT: `${ENUM__redux_slice.GENERATION}/set_field_image_to_edit`,
  GENERATION_UPSERT: `${ENUM__redux_slice.GENERATION}/upsert`,
  GENERATION_SET_CURRENT: `${ENUM__redux_slice.GENERATION}/setCurrent`,
  GENERATION_SET_NEXT: `${ENUM__redux_slice.GENERATION}/set_next`,

  /*
   * GENERATION PRICE
   */

  GENERATION_PRICE_UPSERT_GENERATION_PRICE_BY_HASH: `${ENUM__redux_slice.GENERATION_PRICE}/upsert_generation_price_by_hash`,
  GENERATION_PRICE_DELETE_GENERATION_PRICE_BY_DIFFUSION_MODEL_ID: `${ENUM__redux_slice.GENERATION_PRICE}/delete_generation_price_by_diffusion_model_id`,

  /*
   * GRID2D
   */

  GRID2D_CHUNK_UPSERT: `${ENUM__redux_slice.GRID2D}/grid2d_chunk_upsert`,
  GRID2D_CHUNK_UPDATE_WITHOUT_CELLS: `${ENUM__redux_slice.GRID2D}/grid2d_chunk_update_without_cells`,

  GRID2D_UPSERT: `${ENUM__redux_slice.GRID2D}/grid2d_upsert`,
  GRID2D_UPDATE_PARTIAL: `${ENUM__redux_slice.GRID2D}/grid2d_update_partial`,
  GRID2D_DELETE: `${ENUM__redux_slice.GRID2D}/grid2d_delete`,

  GRID2D_CELLS_UPSERT: `${ENUM__redux_slice.GRID2D}/grid2d_cells_upsert`,
  GRID2D_CELLS_DELETE: `${ENUM__redux_slice.GRID2D}/grid2d_cells_delete`,

  /*
   * USER TASKS
   */
  USER_TASK_UPSERT: `${ENUM__redux_slice.GENERATION}/user_task_upsert`,
  USER_TASK_UPDATE_WITHOUT_GENERATIONS: `${ENUM__redux_slice.GENERATION}/user_task_update_without_generations`,
  USER_TASK_DELETE: `${ENUM__redux_slice.GENERATION}/user_task_delete`,

  /*
   * FULLSCREEN
   */

  /*
   * IMAGES
   */

  IMAGES_ADD_TO_LOADING_POOL: `${ENUM__redux_slice.IMAGES}/add_to_loading_pool`,
  IMAGES_UPSERT: `${ENUM__redux_slice.IMAGES}/upsert`,
  IMAGES_UPSERT_META: `${ENUM__redux_slice.IMAGES}/upsert_meta`,

  IMAGES_AI_DESCRIPTION_UPSERT: `${ENUM__redux_slice.IMAGES}/ai_description_upsert`,

  /*
   * SEARCH
   */
  SEARCH_SET_CURRENT: `${ENUM__redux_slice.SEARCH}/set_current`,
  SEARCH_UPSERT: `${ENUM__redux_slice.SEARCH}/upsert`,
  SEARCH_DELETE: `${ENUM__redux_slice.SEARCH}/delete`,

  /*
   * USER
   */
  USER_AUTH_SET_PAGE_AFTER_LOGIN: `${ENUM__redux_slice.USER}/auth_set_page_after_login`,
  USER_AUTH_LOGOUT: `${ENUM__redux_slice.USER}/auth_logout`,

  USER_SETTINGS_UPSERT: `${ENUM__redux_slice.USER}/settings_upsert`,

  USER_TUTORIAL_UPSERT: `${ENUM__redux_slice.USER}/tutorial_upsert`,
  USER_TUTORIAL_ON_SENT_TO_SERVER: `${ENUM__redux_slice.USER}/tutorial_on_sent_to_server`,

  /*
   * UI
   */

  UI__GRID2D__SET_CURRENT_CELL: `${ENUM__redux_slice.UI}/grid2d_set_current_cell`,
  UI__GRID2D__SET_CURRENT_CELL_NEIGBOURS: `${ENUM__redux_slice.UI}/grid2d_set_current_cell_neigbours`,
  UI__IMAGE__SET_FIELD_FOR_GENERATION_LAYOUT: `${ENUM__redux_slice.UI}/set_field_for_generation_layout`,

  UI_DRAG_AND_DROP_SET_HOVERED_GRAPH_FIELD: `${ENUM__redux_slice.UI}/drag_and_drop_set_hovered_graph_field`,
  UI_DRAG_AND_DROP_SET_IMAGE_DRAGGED: `${ENUM__redux_slice.UI}/drag_and_drop_set_image_dragged`,

  UI_KEY_SET_IS_SHIFT_PRESSED: `${ENUM__redux_slice.UI}/key_set_is_shift_pressed`,

  UI_SET_BOOLEAN: `${ENUM__redux_slice.UI}/set_boolean`,
  UI_SET_NUMBER: `${ENUM__redux_slice.UI}/set_number`,
  UI_SET_STRING: `${ENUM__redux_slice.UI}/set_string`,
  UI_SET_IMAGE: `${ENUM__redux_slice.UI}/set_image`,
  UI_PUT_SET_OF_STRINGS: `${ENUM__redux_slice.UI}/put_set_of_strings`,

  UI_GENERATION_OUTPUT_IMAGE_PREVIEW_SET: `${ENUM__redux_slice.UI}/generation_output_image_preview_set`,
  UI_GENERATION_GRID2D_SET_HOVERED_DIMENSIONS: `${ENUM__redux_slice.UI}/generation_grid2d_set_hovered_dimensions`,

  UI_GENERATION_GRAPH_SET_FIELD_TO_CREATE_NEW_EDGE: `${ENUM__redux_slice.UI}/generation_graph_set_field_to_create_new_edge`,
  UI_GENERATION_GRAPH_SET_HOVERED_FIELD: `${ENUM__redux_slice.UI}/generation_graph_set_hovered_field`,
  UI_GENERATION_SET_BUTTON_GRID2D_DIMENSION_HOVERED: `${ENUM__redux_slice.UI}/generation_set_button_grid2d_dimension_hovered`,

  UI_GENERATION_GENERAL__SIDEBAR_FIELD_HOVERED_SET: `${ENUM__redux_slice.UI}/generation_general__sidebar_field_hovered_set`,
  UI_GENERATION_INPUTS__FILTER_SET: `${ENUM__redux_slice.UI}/generation_inputs__filter_set`,

  UI_PAGE_TASKS_SET_NEW_TASK_ID: `${ENUM__redux_slice.UI}/page_tasks_set_new_task_id`,

  UI_HINT_SHORTCUT_SHOW: `${ENUM__redux_slice.UI}/hint_shortcut_show`,
  UI_HINT_SHORTCUT_HIDE: `${ENUM__redux_slice.UI}/hint_shortcut_hide`,

  /*
   * VISION
   */

  /*
   * WORDS
   */

  WORDS_UPSERT: `${ENUM__redux_slice.WORDS}/words_upsert`,
  WORDS_SIMILAR_UPSERT: `${ENUM__redux_slice.WORDS}/words_similar_upsert`,

  WORDS_TRANSLATING_IN_PROGRESS_ADD: `${ENUM__redux_slice.WORDS}/translating_in_progress_add`,
  WORDS_TRANSLATING_IN_PROGRESS_DELETE: `${ENUM__redux_slice.WORDS}/translating_in_progress_delete`,

  /*
   * WORD WITH RELATED WORDS
   */
  WORDS_WITH_RELATED_WORDS_SET_WORD_FOR_ADDING_RELATED_WORDS: `${ENUM__redux_slice.WORDS}/set_word_for_adding_related`,

  WORDS_WITH_RELATED_WORDS_UPSERT: `${ENUM__redux_slice.WORDS}/words_with_related_words_upsert`,

  WORDS_WITH_RELATED_WORDS_GET_IN_PROGRESS_ADD: `${ENUM__redux_slice.WORDS}/word_with_related_words_get_in_progress_add`,
  WORDS_WITH_RELATED_WORDS_GET_IN_PROGRESS_DELETE: `${ENUM__redux_slice.WORDS}/word_with_related_words_get_in_progress_delete`,

  WORDS_WITH_RELATED_WORDS_CREATE_IN_PROGRESS_ADD: `${ENUM__redux_slice.WORDS}/word_with_related_words_create_in_progress_add`,
  WORDS_WITH_RELATED_WORDS_CREATE_IN_PROGRESS_DELETE: `${ENUM__redux_slice.WORDS}/word_with_related_words_create_in_progress_delete`,

  /*
   * WORKSPACE
   */
  WORKSPACE_UPSERT: `${ENUM__redux_slice.WORKSPACE}/workspace_upsert`,
  WORKSPACE_DELETE: `${ENUM__redux_slice.WORKSPACE}/workspace_delete`,

  WORKSPACE_USER_UPSERT: `${ENUM__redux_slice.WORKSPACE}/workspace_user_upsert`,
  WORKSPACE_USER_DELETE: `${ENUM__redux_slice.WORKSPACE}/workspace_user_delete`,

  WORKSPACE_USER_INVITATION_UPSERT: `${ENUM__redux_slice.WORKSPACE}/workspace_user_invitation_upsert`,
  WORKSPACE_USER_INVITATION_DELETE: `${ENUM__redux_slice.WORKSPACE}/workspace_user_invitation_delete`,

  WORKSPACE_CHILD_ENTITY_SET_CURRENT_VIEWED: `${ENUM__redux_slice.WORKSPACE}/set_current_viewed`,

  WORKSPACE_CHILD_ENTITY_VIEWER_UPSERT: `${ENUM__redux_slice.WORKSPACE}/workspace_child_entity_viewer_upsert`,
  WORKSPACE_CHILD_ENTITY_VIEWER_DELETE: `${ENUM__redux_slice.WORKSPACE}/workspace_child_entity_viewer_delete`,
  WORKSPACE_CHILD_ENTITY_VIEWER_DELETE_BY_ENTITY_DATA: `${ENUM__redux_slice.WORKSPACE}/workspace_child_entity_viewer_delete_by_entity_data`,

  WORKSPACE_SET_CURRENT: `${ENUM__redux_slice.WORKSPACE}/set_current`,
  WORKSPACE_SET_IS_ALL_DATA_LOADED: `${ENUM__redux_slice.WORKSPACE}/set_is_all_data_loaded`,

  WORKSPACE_TRANSFER_OWNERSHIP_PROPOSAL_UPSERT: `${ENUM__redux_slice.WORKSPACE}/workspace_transfer_ownership_proposal_upsert`,
  WORKSPACE_TRANSFER_OWNERSHIP_PROPOSAL_DELETE: `${ENUM__redux_slice.WORKSPACE}/workspace_transfer_ownership_proposal_delete`,

  /*
   * WORKSPACE BILLING
   */
  WORKSPACE_BILLING_BALANCE_UPSERT: `${ENUM__redux_slice.WORKSPACE_BILLING}/balance_upsert`,
  WORKSPACE_BILLING_BALANCE_DELETE: `${ENUM__redux_slice.WORKSPACE_BILLING}/balance_delete`,

  WORKSPACE_BILLING_SUBSCRIPTIONS_UPSERT: `${ENUM__redux_slice.WORKSPACE_BILLING}/subscriptions_upsert`,
  WORKSPACE_BILLING_SUBSCRIPTIONS_DELETE: `${ENUM__redux_slice.WORKSPACE_BILLING}/subscriptions_delete`,

  WORKSPACE_BILLING_CREDITS_TRANSACTIONS_UPSERT: `${ENUM__redux_slice.WORKSPACE_BILLING}/credits_transactions_upsert`,
  WORKSPACE_BILLING_PAYMENT_TRANSACTIONS_UPSERT: `${ENUM__redux_slice.WORKSPACE_BILLING}/payment_transactions_upsert`,
};
